import { render } from "./DeleteModal.vue?vue&type=template&id=203f617a&scoped=true"
import script from "./DeleteModal.vue?vue&type=script&lang=js"
export * from "./DeleteModal.vue?vue&type=script&lang=js"

import "./DeleteModal.vue?vue&type=style&index=0&id=203f617a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203f617a"]])

export default __exports__